import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import day from 'dayjs'

import GeneratePdf from '../../utils/PdfUtil'
import downloadBlob from '../../utils/DomUtils'
import pdfBase from '../../certificate.pdf'

import Footer from '../molecule/Footer'

class Generate extends Component {
    constructor(props) {
        super(props)
        this.state = {
            form: {
                first_name: '',
                last_name: '',
                birthday: '',
                birth_city: '',
                address: '',
                city: '',
                zip_code: '',
                reason: '',
                out_date: '',
                out_hour: ''
            }
        }
    }

    download = async e => {
        e.preventDefault()
        const blob = await GeneratePdf(this.state.form, this.state.form.reason, pdfBase)
        await downloadBlob(blob, 'attestation')
    }

    async componentDidMount() {
        const getParam = (name) => {
            let url = new URL(window.location.href)
            let params = new URLSearchParams(url.search)
            return params.get(name)
        }

        const data = {
            first_name: getParam('first_name'),
            last_name: getParam('last_name'),
            birthday: getParam('birthday'),
            birth_city: getParam('birth_city'),
            address: getParam('address'),
            city: getParam('city'),
            zip_code: getParam('zip_code'),
            reason: getParam('reason'),
            out_date: day().format('DD/MM/YYYY'),
            out_hour: day().format('HH:mm')
        }

        await this.setState({
            form: data
        })
    }

    render() {
        return(
            <div className="generate">
                <div className="buttons">
                    <button onClick={this.download}>Générer mon attestation</button>
                    <Link to='/'>
                        <button className="secondary">Créer un autre raccourci</button>
                    </Link>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default Generate